import { render } from "./PalletReceivingContent.vue?vue&type=template&id=52503736"
import script from "./PalletReceivingContent.vue?vue&type=script&lang=js"
export * from "./PalletReceivingContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__